import axios from "axios";
import { environment } from "environment";

import { authService } from "services/authService";
import {i18nProvider} from "./i18nProvider";

export const backendUrl = `${environment.useSsl ? "https" : "http"}://${
  environment.apiDomain
}`

export const axiosInstance = axios.create({
  baseURL: backendUrl,
  paramsSerializer: {
    indexes: null,
  },
});

axiosInstance.interceptors.request.use((request) => {
  const token = localStorage.getItem("accessToken");
  if (token && request.headers) {
    request.headers["Authorization"] = "Bearer " + token;
  }

  const currentLocale = i18nProvider.getLocale();
  request.headers['Accept-Language'] = currentLocale;

  return request;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    return new Promise((resolve, reject) => {

      console.log(window.location.href)

      if (
        error?.response?.status === 401 &&
        error?.response?.data?.message === "Token is expired"
      ) {
        console.warn(`Token ${localStorage.getItem("accessToken")} is expired`);
        authService
          .refreshToken()
          .then(() => {
            error.config.headers["Authorization"] =
              "Bearer " + localStorage.getItem("accessToken");

            axios.request(error.config).then((response) => {
              resolve(response);
            }).catch((error) => {
              reject(error);
            });
          })
          .catch((error) => {
            reject(error);
          });
      } else if (error?.response?.status === 401 && !window.location.href.endsWith("/login")) {
        console.warn(error);
        window.location.href = "/login";
      } else {
        reject(error);
      }
    });
  }
);
